<div (click)="onClick()" class="wallet-container">
    <button class="wallet-display ps-2" title="Open wallet">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="wallet-icon">
            <path
                d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1">
            </path>
            <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path>
        </svg>
        <app-shimmer-loader *ngIf="wallet?.unpaidTotal == undefined" width="60px" height="14px"></app-shimmer-loader>

    </button>
    <span class="wallet-amount" *ngIf="!isAmountHidden && wallet?.unpaidTotal !=undefined" [ngClass]="getAmountClass()">
        <span style="padding-top: 2px;">{{AmountUtils.formatAmount(wallet?.unpaidTotal, 'EUR')}}</span>
    </span>
    <span class="wallet-amount" *ngIf="isAmountHidden">
        ••••
    </span>
    <button class="toggle-visibility-btn" (click)="toggleAmountVisibility($event); $event.stopPropagation();"
        [title]="isAmountHidden ? 'Show amount' : 'Hide amount'">
        <svg *ngIf="!isAmountHidden" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
            <circle cx="12" cy="12" r="3"></circle>
        </svg>
        <svg *ngIf="isAmountHidden" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path
                d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24">
            </path>
            <line x1="1" y1="1" x2="23" y2="23"></line>
        </svg>
    </button>
</div>